"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  notificationRecipient: 'ORGANISATION_UNIT_CONTACT',
  deliveryChannels: [],
  notifyUsersInHierarchyOnly: false
};
exports.default = _default;
//# sourceMappingURL=validationNotificationTemplate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/validationNotificationTemplate.js
// module id = 1236
// module chunks = 0